<template>
  <ul
    class="h-[528px] overflow-y-scroll scrollable px-1.5 flex flex-col gap-4"
  >
    <PWishesSkeleton
      v-for="n in 10"
      :key="n"
    />
  </ul>
</template>
